import { ReactElement, useEffect, useState } from 'react';

type Props = {
  children: ReactElement;
  delay: number;
};

function Delay(props: Props) {
  const { children, delay } = props;

  const [timeOut, setTimeOut] = useState(false);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setTimeOut(true);
    }, delay);

    return () => clearTimeout(timeoutId);
  }, [delay]);

  return timeOut ? children : null;
}

Delay.defaultProps = {
  delay: 1000,
};

export default Delay;
